<div class="row row-eq-height icons-view p-2" *transloco="let t; read: 'widgets.common'">
  <span *ngIf="showHeader" class="text-center font-size-18 card-title-desc" hidden>{{ t("adminTitle") }}</span>

  <div *ngFor="let widget of widgets" class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-6 item-icon-view bg-light">
    <app-widget-tile
      [widgetData]="widget"
      [isAdmin]="isAdmin"
      (toggleClick)="onWidgetChange($event)"
      (settingClick)="onWidgetSettingsClick($event)"
      (demoClick)="onWidgetDemoClick($event)"
      (previewClick)="onWidgetPreviewClick($event)"
      (deleteClick)="onWidgetDeleteClick($event)"
    ></app-widget-tile>
  </div>
</div>
